import { onMounted, onUnmounted, ref } from 'vue';

export function useIsMobile() {
  const isMobile = ref(
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    ),
  );

  const isSmallScreen = ref(window.innerWidth <= 768);

  const updateScreenSize = () => {
    isSmallScreen.value = window.innerWidth <= 768;
  };

  onMounted(() => {
    window.addEventListener('resize', updateScreenSize);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', updateScreenSize);
  });

  return { isMobile, isSmallScreen };
}
